// extracted by mini-css-extract-plugin
export default {"autocompleteContainer":"ClientPalletsTransferHistoryFiltersModal_autocompleteContainer__P+1Fr"};